// @flow
import React, { Component } from 'react';
import i18n from 'app/common/lib/i18n';
import { Box, Icon, Text, Touchable } from 'gestalt';

type ConnectButtonProps = {|
  buttonBackgroundColor: string,
  buttonText: string,
  handleSocialConnectClick: (string) => void,
  socialMedia: string,
|};

type State = {|
  hover: boolean,
|};

export default class SocialConnectButton extends Component<ConnectButtonProps, State> {
  state: State = {
    hover: false,
  };

  getButtonStyle() {
    const buttonStyle = {};
    buttonStyle.borderRadius = '4px';

    const padding = this.props.socialMedia === 'gplus' ? '6px 40px 6px 0px' : '6px 20px 6px 0px';
    let textColor = '';
    let bgColor = '';

    if (this.props.buttonBackgroundColor === 'white') {
      bgColor = '#FFFFFF';
      if (this.props.socialMedia === 'facebook') {
        textColor = '#3B5998';
      } else if (this.props.socialMedia === 'gplus') {
        textColor = '#0084FF';
      }
    } else if (this.props.buttonBackgroundColor === 'blue') {
      textColor = '#FFFFFF';
      if (this.props.socialMedia === 'facebook') {
        bgColor = '#3B5998';
      } else if (this.props.socialMedia === 'gplus') {
        bgColor = '#0084FF';
      }
    } else if (this.props.buttonBackgroundColor) {
      bgColor = this.props.buttonBackgroundColor;
      textColor = '#328af5';
    }

    if (this.state.hover) {
      bgColor = '#EDEDED';
    }

    buttonStyle.color = textColor;
    buttonStyle.padding = padding;
    buttonStyle.backgroundColor = bgColor;

    return buttonStyle;
  }

  getFacebookIcon() {
    return (
      <Box
        // Getting rid of a navy pixel on 4 corners
        dangerouslySetInlineStyle={{ __style: { borderRadius: 10, backgroundColor: '#3B5998' } }}
        height={24}
        marginLeft={2}
        position="relative"
        left
        width={24}
      >
        <Icon
          accessibilityLabel={i18n._('facebook', 'accessible label for facebook icon')}
          color={this.state.hover ? 'lightGray' : 'white'}
          icon="facebook"
          inline
          size={24}
        />
      </Box>
    );
  }

  getGPlusIcon() {
    return (
      <Box
        alignSelf="center"
        color={this.state.hover ? 'lightGray' : 'white'}
        display="flex"
        height={24}
        marginLeft={2}
        position="relative"
        width={24}
      >
        {this.logo(24)}
      </Box>
    );
  }

  logo(size: number) {
    return (
      <svg height={size} viewBox="0 0 512 512" width={size} xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path
            d={
              'M482.56 261.36c0-16.73-1.5-32.83-4.29-48.27H256v91.29h127.01c-5.47 29.5-22.1 54.49-47.09 71.23v59.2' +
              '1h76.27c44.63-41.09 70.37-101.59 70.37-173.46z'
            }
            fill="#4285f4"
          />
          <path
            d={
              'M256 492c63.72 0 117.14-21.13 156.19-57.18l-76.27-59.21c-21.13 14.16-48.17 22.53-79.92 22.53-61.4' +
              '7 0-113.49-41.51-132.05-97.3H45.1v61.15c38.83 77.13 118.64 130.01 210.9 130.01z'
            }
            fill="#34a853"
          />
          <path
            d={
              'M123.95 300.84c-4.72-14.16-7.4-29.29-7.4-44.84s2.68-30.68 7.4-44.84V150.01H45.1C29.12 181.87 20 217.9' +
              '2 20 256c0 38.08 9.12 74.13 25.1 105.99l78.85-61.15z'
            }
            fill="#fbbc05"
          />
          <path
            d={
              'M256 113.86c34.65 0 65.76 11.91 90.22 35.29l67.69-67.69C373.03 43.39 319.61 20 256 20c-92.25 0-17' +
              '2.07 52.89-210.9 130.01l78.85 61.15c18.56-55.78 70.59-97.3 132.05-97.3z'
            }
            fill="#ea4335"
          />
          <path d="M20 20h472v472H20V20z" />
        </g>
      </svg>
    );
  }

  handleConnectClick = () => {
    this.props.handleSocialConnectClick(this.props.socialMedia);
  };

  toggleHover = () => {
    this.setState({ hover: !this.state.hover });
  };

  renderSocialConnectButton() {
    const buttonStyle = this.getButtonStyle();
    return (
      <Box
        marginRight={2}
        onMouseEnter={this.toggleHover}
        onMouseLeave={this.toggleHover}
        width={245}
        height={38}
      >
        <Touchable onTouch={this.handleConnectClick}>
          <Box
            alignItems="center"
            display="flex"
            position="relative"
            dangerouslySetInlineStyle={{ __style: buttonStyle }}
          >
            {this.props.socialMedia === 'facebook' ? this.getFacebookIcon() : this.getGPlusIcon()}
            <Box marginLeft={4}>
              <Text weight="bold">
                <span style={{ color: buttonStyle.color }}>{this.props.buttonText}</span>
              </Text>
            </Box>
          </Box>
        </Touchable>
      </Box>
    );
  }

  render() {
    return this.renderSocialConnectButton();
  }
}
